/* paragraph.styled.ts */
import { css, styled } from 'styled-components';
import { fontSizes, lineHeights, fontWeights, colors, responsiveBreakPoints } from '@styles/DesignVariables';
const { maxTablet } = responsiveBreakPoints;

export type ParagraphVariants = 'tiny' | 'small' | 'normal' | 'heading' | 'regular';

interface StyledParagraph {
	$variant: ParagraphVariants;
	$color?: string;
	$linkColor?: string;
}

export const defaultParagraph = css`
	font-size: ${fontSizes.smallParagraph};
	line-height: ${lineHeights.smallParagraph};
	font-weight: ${fontWeights.normal};
	margin: 0 !important;
	white-space: normal;
	@media screen and (${maxTablet}) {
		font-size: 12px;
		line-height: 16px;
	}
`;

export const tinyParagraph = css`
	font-size: ${fontSizes.tinyParagraph};
	line-height: ${lineHeights.tinyParagraph};
	font-weight: ${fontWeights.bold};
	white-space: normal;
`;

export const smallParagraph = css`
	font-size: ${fontSizes.smallParagraph};
	line-height: ${lineHeights.smallParagraph};
	font-weight: ${fontWeights.normal};
	@media screen and (${maxTablet}) {
		font-size: 12px;
		line-height: 16px;
	}
`;

export const normalParagraph = css`
	font-size: ${fontSizes.normalParagraph};
	line-height: 150%;
	font-weight: ${fontWeights.normal};
	@media screen and (${maxTablet}) {
		font-size: ${fontSizes.normalParagraphMobile};
		line-height: 150%;
	}
	a {
		font-weight: 700;
	}
`;

export const regularParagprath = css`
	font-size: ${fontSizes.font14};
	line-height: 18px;
	font-weight: ${fontWeights.normal};
`;

export const normalHeading = css`
	font-size: ${fontSizes.cardHeading};
	line-height: ${lineHeights.cardHeading};
	font-weight: ${fontWeights.bold};
`;

export const ParagraphStyled = styled.div<StyledParagraph>`
	${defaultParagraph};

	${(props) => {
		switch (props.$variant) {
			case 'tiny':
				return tinyParagraph;
			case 'regular':
				return regularParagprath;
			case 'small':
				return smallParagraph;
			case 'normal':
				return normalParagraph;
			case 'heading':
				return normalHeading;
			default:
				return defaultParagraph;
		}
	}};

	/* default colour, overridable with $color */
	color: ${({ $color }) => $color ?? colors.paragraphText};

	a {
		color: ${({ $linkColor }) => $linkColor};
		text-decoration: underline;
		font-weight: 700;
		cursor: pointer;
	}
`;
